module.exports = __webpack_public_path__ + "static/media/study.3cd96845.svg";